import { render } from "./WaterHome.vue?vue&type=template&id=4f7c0113&scoped=true"
import script from "./WaterHome.vue?vue&type=script&lang=js"
export * from "./WaterHome.vue?vue&type=script&lang=js"

import "./WaterHome.vue?vue&type=style&index=0&id=4f7c0113&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7c0113"]])

export default __exports__